import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Canvas, fabric } from 'fabric';
import * as cloneDeep from 'lodash/cloneDeep';
import { Subscription, timer } from 'rxjs';
import { Attachment, FabricModel, NodeDetailModel } from 'src/app/models/index';
import {
  ClickAndNavigationService,
  CommonService,
  LoadService,
  SiteService
} from 'src/app/services/index';
import { ActionModeEnum, AlertService, Constants } from 'src/app/shared';
import { FabricService } from 'src/app/shared/index';
import { AddNodeDetailModalComponent } from '../add-node-detail-modal/add-node-detail-modal.component';
@Component({
  selector: 'app-upload-image-modal',
  templateUrl: './upload-image-modal.component.html',
  styleUrls: ['./upload-image-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadImageModalComponent
  implements OnInit, AfterViewChecked, AfterViewInit
{
  modalInstant: any;
  formData: UntypedFormGroup;
  tagParameters = {
    loadName: ''
  };
  activeTabIndex = 0;
  loadImgFileContents: any;
  rowsAndColumns = 0;
  loadAttachment: Attachment = new Attachment();
  immediateChildEntites: any;
  selectedDivID: number;
  submitted: boolean;
  divClassName = 'splitImg';
  public selectedEntityName: string;
  public selectedEntityRId: string;
  public siteId: string;
  public immediateChildNodes: any;
  // Using Canvas
  canvas: Canvas;
  canvasGroup: fabric.Group;
  currentMousePosition: any;
  nodeDetail: NodeDetailModel;
  originalNodeDetail: NodeDetailModel;
  inputSensors: any;
  outputSensors: any;
  imageBinary = '';
  canvasOriginalWidth: number;
  canvasOriginalHeight = 650;
  canvasWidth: number;
  canvasHeight = 650;
  imgWidth: number;
  imgHeight: 650;
  canvasScaleX = 1;
  canvasScaleY = 1;
  isViewInit = false;
  nodeDetailsList = [];
  node: any;
  clickAndNavigateLevelItem: number;
  rtDataLength: number;
  displayHydraulicDataTable: boolean;
  clickAndNavigatePageRefreshFlag: number;
  returnedJSONArray: any;
  clickAndNavigateDashboarInterval = 60 * 3; // 3 minutes
  intervalForClickAndNavigateRefresh = undefined;
  subscription: Subscription;
  clickAndNavigateTreeData: any;
  meterIDbasedOnVG: any;
  electricalParameters = ['voltage', 'current', 'powerfactor', 'realtimepower'];
  quickStatsParameters = ['Energy', 'SystemHealth'];
  quickStatSensorHealth = '';
  quickStatSensorHealthMsg = '';
  quickStatsData: any;
  sensorLastUpdatedTxtime = '';
  breadCrumData: any;
  loadRTData: any;
  constructor(
    private dialogRef: MatDialogRef<UploadImageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private alertService: AlertService,
    private siteService: SiteService,
    private fabricService: FabricService,
    private commonService: CommonService,
    private clickAndNavigationService: ClickAndNavigationService,
    private cdRef: ChangeDetectorRef,
    private loadService: LoadService,
    private fb: UntypedFormBuilder
  ) {
    if (data) {
      this.siteId = data.siteId;
      this.immediateChildNodes = data.immediateChildNodes;
      this.node = data.nodeData;
      this.clickAndNavigateTreeData = data.clickAndNavigateTreeData;
    }
  }

  ngOnInit() {
    this.formData = this.fb.group({
      loadnameCtr: ['']
      // rowsAndColumnsCtr: ['',  [Validators.required, Validators.min(0), Validators.max(12)]],
    });
    this.modalInstant = this;
    this.commonService.getNodeTreeDetailSubject().subscribe((data) => {
      // create text
      const option = this.getFabricOptionBasedOnMouseClick();
      this.bindNodeDetail(true, data, option);
      const text = this.fabricService.fabricTextInRect(this.nodeDetail);
      const IdObj = this.fabricService.fabricIdInRect(this.nodeDetail);
      const sensorIdObj = this.fabricService.fabricSensorIdInRect(
        this.nodeDetail
      );

      option.width = text.width + 10;
      option.height = text.height + 20;
      const rect = this.fabricService.fabricRectonTree(this.nodeDetail);
      // add Rect and text to a group
      // It is possible to listen for events on the inner object by adding the option: subTargetCheck: true to the fabric
      const group = new fabric.Group([rect, text, IdObj, sensorIdObj], {
        selectable: false,
        subTargetCheck: true
      });
      // detect Editing, Adding, or Delete mode
      switch (data.actionMode) {
        case ActionModeEnum.Creating: {
          this.nodeDetailsList.push(this.nodeDetail);
          this.canvas.add(group);
          // this.canvas.getActiveObject().id = this.nodeDetail.nodeId;
          this.canvas.renderAll();
          break;
        }
        case ActionModeEnum.Editing:
        case ActionModeEnum.Deleting: {
          const objects = this.canvas.getObjects();
          for (let i = 0; i < objects.length; i++) {
            const obj = <any>objects[i];
            if (
              Array.from(obj._objects).filter(
                (x: any) => x.nodeId === this.originalNodeDetail.nodeId
              ).length > 0
            ) {
              this.canvas.remove(obj);
              this.canvas.renderAll();
              break;
            }
          }
          const index = this.nodeDetailsList.findIndex(
            (x) => x.nodeId === this.nodeDetail.nodeId
          );
          if (data.actionMode === ActionModeEnum.Editing) {
            if (index !== -1) {
              this.nodeDetailsList[index] = this.nodeDetail;
            }
            this.canvas.add(group);
            this.canvas.renderAll();
          } else {
            if (index !== -1) {
              this.nodeDetailsList.splice(index, 1);
            }
          }
          break;
        }
        default: {
          break;
        }
      }
      // reset actionMode
      this.nodeDetail.actionMode = ActionModeEnum.Creating;
      // mousedown mouse:down' => not working
      group.on('mousedown', this.onEditNodeDetail);
    });
  }
  ngAfterViewInit() {
    // this.cdRef.detectChanges();
    window.addEventListener('resize', this.resizeCanvas);
  }
  ngAfterViewChecked() {
    // this.cdRef.detectChanges();
  }
  close(confirm: boolean) {
    this.dialogRef.close({ status: confirm, data: null });
  }
  navigate($event: MatTabChangeEvent) {
    // const tab = this.lineManagementTabs[$event.index];
    // this.router.navigate(['site/solar-dashboard/', tab.path], { queryParams: { siteId: this.siteId } });
  }
  // Upload Image
  // To UPLOAD the IMAGE
  public selectDocument = (elmId: string) => {
    const element: HTMLElement = document.getElementById(elmId);
    element!.click();
  };
  public uploadDocument = (event: any, pictType: string) => {
    if (event.target.files.length <= 0) {
      return;
    }
    const files = event.target.files;
    if (!this.commonService.isImageFile(files[0])) {
      this.commonService.showDialogMessage('File type not supported!');
      return;
    }
    const formData = new FormData();
    formData.append('file', files[0]);
    formData.append('documentType', pictType);
    // this.preview(files[0]);
    // this.loadAttachment = files[0].id;
    this.siteService
      .uploadDocument(formData, pictType, this.node.nodeId, this.siteId)
      .subscribe((data) => {
        if (data === '' || this.commonService.isNullOrUndefined(data)) {
          this.alertService.showError('Upload file fail!');
          return;
        }
        this.loadAttachment = data;
        this.loadImgFileContents = `data:image/jpeg;base64, ${data.fileContent}`;
        // this.loadImgFileContents = `${API_BASE$}/${data.renderUrl}`;
        this.initLoadImageCanvas(data.fileContent);
      });
  };
  private initLoadImageCanvas = (fileContent: string) => {
    this.canvas = new fabric.Canvas('loadImgCanvas', {
      hoverCursor: 'pointer',
      selection: false,
      selectionBorderColor: 'green',
      backgroundColor: null
    });
    this.setCanvasSize();
    const canvasSelf = this.canvas;
    const self = this;
    const ctx = this.canvas.getContext();
    const imgObj = new Image();
    imgObj.src = `data:image/jpeg;base64,${fileContent}`;
    // imgObj.src = `${fileContent}`;
    imgObj.onload = function () {
      ctx.drawImage(imgObj, 0, 0);
      const image = new fabric.Image(imgObj);
      const options = self.getImageOptions(image);
      canvasSelf.setBackgroundImage(
        image,
        canvasSelf.renderAll.bind(canvasSelf),
        options
      );
      canvasSelf.on('mouse:dblclick', self.onImageClick);
      canvasSelf.renderAll();
    };
  };
  private getImageOptions = (image: fabric.Image) => {
    const self = this;
    // Get image size from uploading after draw
    const canvasAspect = self.canvasWidth / self.canvasHeight;
    const imgAspect = image.width / image.height;
    let scaleX = 0;
    let scaleY = 0;
    // let scaleFactor: number;
    if (canvasAspect >= imgAspect) {
      scaleX = 1;
      scaleY = 1;
    } else {
      scaleX = self.canvasWidth / image.width;
      scaleY = self.canvasHeight / image.height;
    }
    return {
      top: 0,
      left: 0,
      originX: 'left',
      originY: 'top',
      scaleX: scaleX,
      scaleY: scaleY
    };
  };
  private resizeCanvas = () => {
    setTimeout(() => {
      if (this.canvas !== undefined && this.canvas.backgroundImage) {
        this.setCanvasSize(true);
        const bi = <fabric.Image>this.canvas.backgroundImage;
        const options = this.getImageOptions(bi);
        // bi.left = options.left;
        // bi.top = options.top;
        bi.scaleX = options.scaleX;
        bi.scaleY = options.scaleY;
        const objects = this.canvas.getObjects();
        for (let i = 0; i < objects.length; i++) {
          const scaleX = objects[i].scaleX;
          const scaleY = objects[i].scaleY;
          const left = objects[i].left;
          const top = objects[i].top;
          const tempScaleX = scaleX * this.canvasScaleX;
          const tempScaleY = scaleY * this.canvasScaleY;
          const tempLeft = left * this.canvasScaleX;
          const tempTop = top * this.canvasScaleY;
          objects[i].scaleX = tempScaleX;
          objects[i].scaleY = tempScaleY;
          objects[i].left = tempLeft;
          objects[i].top = tempTop;
          objects[i].setCoords();
        }
        this.canvas.renderAll();
        this.canvas.calcOffset();
      }
    }, 700);
  };
  private setCanvasSize = (isResized: boolean = false) => {
    const temp = document.querySelector('#wrapper');
    if (temp) {
      const bcr = temp.getBoundingClientRect();
      this.canvasWidth = bcr.right - bcr.left;
      if (isResized && this.canvasOriginalWidth !== undefined) {
        this.canvasScaleX = this.canvasWidth / this.canvasOriginalWidth;
      }
      this.canvasOriginalWidth = cloneDeep(this.canvasWidth);
      this.canvas.setWidth(this.canvasWidth);
      this.canvas.setHeight(this.canvasHeight);
    }
  };
  private getFabricOptionBasedOnMouseClick = () => {
    return new FabricModel(
      this.currentMousePosition.x,
      this.currentMousePosition.y
    );
  };
  private onImageClick = (e: any) => {
    this.currentMousePosition = this.fabricService.getMousePosition(
      'loadImgCanvas',
      e.e.clientX,
      e.e.clientY
    );
    this.bindNodeDetail(false, null, null);
    this.onShowDialogNodeDetail(this.nodeDetail);
  };
  private bindNodeDetail = (isEditing: boolean, data?: any, option?: any) => {
    // const newLoad = this.cloneDeepLoad();
    if (isEditing) {
      this.nodeDetail = new NodeDetailModel();
      this.nodeDetail.nodeId = data.nodeId;
      this.nodeDetail.nodeName = data.nodeName;
      this.nodeDetail.assignSensor = data.assignSensor;
      this.nodeDetail.fabricOption = option;
      this.nodeDetail.selectedEnity = data.selectedEnity;
      this.nodeDetail.sensorRIdForSelectedEnity =
        data.sensorRIdForSelectedEnity;
      this.nodeDetail.loadID = data.loadID;
      this.nodeDetail.meterId = data.meterId;
      this.nodeDetail.kpiName = data.kpiName;
      this.nodeDetail.level = data.level;
      this.nodeDetail.monitoredParameter = data.monitoredParameter;
      this.nodeDetail.selectedLoadEntity = data.selectedLoadEntity;

      this.nodeDetail.actionMode = ActionModeEnum.Editing;
    } else {
      this.nodeDetail = new NodeDetailModel();
      this.nodeDetail.actionMode = ActionModeEnum.Creating;
    }
    this.nodeDetail.immediateChildNodes = this.immediateChildNodes;
  };
  private onEditNodeDetail = (e: any) => {
    // e.target._objects[0]
    this.currentMousePosition = this.fabricService.getMousePosition(
      'loadImgCanvas',
      e.e.clientX,
      e.e.clientY
    );
    const currentNode = e.target.getObjects()[0];
    const nodeDetail: NodeDetailModel = new NodeDetailModel();
    Object.assign(nodeDetail, currentNode);
    nodeDetail.actionMode = ActionModeEnum.Editing;
    nodeDetail.immediateChildNodes = this.immediateChildNodes;
    this.nodeDetailsList
      .filter((node) => {
        return node.nodeId === nodeDetail.nodeId;
      })
      .forEach((n) => {
        nodeDetail.level = n.level;
        nodeDetail.selectedEnity = n.selectedEnity;
        nodeDetail.selectedLoadEntity = n.selectedLoadEntity;
        nodeDetail.sensorRIdForSelectedEnity = n.sensorRIdForSelectedEnity;
        nodeDetail.monitoredParameter = n.monitoredParameter;
      });
    this.originalNodeDetail = cloneDeep(nodeDetail);
    if (nodeDetail !== undefined && nodeDetail.nodeName !== undefined) {
      this.onShowDialogNodeDetail(nodeDetail);
    }
  };
  private onShowDialogNodeDetail = (nodeDetail: NodeDetailModel = null) => {
    const dialogConfig: MatDialogConfig = {
      width: '90%',
      data: { nodeDetail: nodeDetail, siteId: this.siteId, nodeData: this.node }
    };
    this.dialog.open(AddNodeDetailModalComponent, dialogConfig);
  };
  preview(fileData) {
    // Show preview
    const mimeType = fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(fileData);
    reader.onload = (_event) => {
      this.loadImgFileContents = reader.result;
      // Using Binary image for Canvas
      this.initLoadImageCanvas(this.loadImgFileContents);
    };
  }
  // Instead of using Canvas
  // Divide image into DIVS
  // drawGridLines() {
  //   const t = this;
  //   const img = new Image();
  //   const length = this.rowsAndColumns;
  //   const ylength = this.rowsAndColumns;
  //   img.src = this.loadImgFileContents;
  //   img.width = 850;
  //   img.height = 650;
  //   const wrapperElement: HTMLElement = document.getElementById('wrapper') as HTMLElement;
  //   wrapperElement.innerHTML = '';
  //   img.onload = function () {
  //     const width = img.width;
  //     const height = img.height;
  //     const _length = -length;
  //     const rowCol = 0;
  //     let divID = 0;
  //     const $wrapper = wrapperElement.style.width = (width + length * 2) + 'px';
  //     for (let i = 0; i > _length; i--) {
  //       for (let j = 0; j > _length; j--) {
  //         const divID_str = 'loadImgDiv_' + divID++;
  //         const basicDiv = document.createElement('div');
  //         basicDiv.setAttribute('class', t.divClassName);
  //         basicDiv.setAttribute('id', divID_str);

  //         basicDiv.style.width = Math.floor(width / length) + 'px';
  //         basicDiv.style.height = Math.floor(height / ylength) + 'px';
  //         basicDiv.style.backgroundImage = 'url(' + t.loadImgFileContents + ')';
  //         basicDiv.style.backgroundPosition = `${width / length * j}px ${height / ylength * i}px`;

  //         const newDiv = basicDiv;
  //         newDiv.addEventListener('click', function() {
  //           t.openAddNodeDetailsModal(this);
  //         });
  //         wrapperElement.appendChild(newDiv);
  //       }
  //     }
  //   };
  // }
  // submitUploadImageDetails() {
  //   const params = {
  //     'parentEntityRId': this.selectedEntityRId,
  //     'loadImgRId': this.loadAttachment.id,
  //     'htmlDivWithLabels': JSON.stringify(document.getElementById('wrapper').innerHTML),
  //     'divClassName': this.divClassName,
  //     'Type': Constants.DOCUMENT_TYPE.CLICK_AND_NAVIGATE_LAYOUT
  //   };
  //   this.loadService.saveNodeDetailsForLoad(params).subscribe(data => {
  //     if (data !== 'Fail') {
  //       this.alertService.showSuccess('Uploaded Successfully..!!') ;
  //     } else {
  //       this.alertService.showError('Failed to upload Image..!!') ;
  //     }
  //   });

  // }
  // using Canvas
  public submitUploadImageDetails = () => {
    let nodeIdStr = this.node.nodeId;
    // For ROOT node
    if (nodeIdStr.toLowerCase().indexOf('level0table_') > -1) {
      nodeIdStr = this.siteId;
    }
    const params = {
      selectedNodeId: nodeIdStr,
      // 'parentEntityId': this.siteId,
      siteId: this.siteId,
      loadImgId: this.loadAttachment.attachmentId,
      htmlDivWithLabels: '',
      divClassName: this.divClassName,
      Type: Constants.DOCUMENT_TYPE.CLICK_AND_NAVIGATE_LAYOUT,
      nodeDetails: ''
    };
    if (this.canvas !== null) {
      const htmlDivWithLabels = JSON.stringify(this.canvas.toJSON());
      params.htmlDivWithLabels = htmlDivWithLabels;
    }
    const nodeDetails = cloneDeep(this.nodeDetailsList);
    if (nodeDetails.length > 0) {
      for (let i = 0; i < nodeDetails.length; i++) {
        delete nodeDetails[i].fabricOption;
        delete nodeDetails[i].actionMode;
        nodeDetails[i].sensorId = nodeDetails[i].sensorRIdForSelectedEnity;
        if (
          nodeDetails[i].level === 'sensor' ||
          nodeDetails[i].level === 'meter'
        ) {
          nodeDetails[i].selectedEnity = nodeDetails[i].nodeId;
        }
      }
      params.nodeDetails = nodeDetails;
    }
    this.loadService.saveNodeDetails(params).subscribe((data) => {
      if (data.code === 200) {
        this.alertService.showSuccess('Uploaded Successfully..!!');
        this.close(false);
      } else {
        this.alertService.showError('Failed to upload Image..!!');
      }
    });
  };
  // Info Tab
  submitSiteDetails() {}

  invertEditFlag() {}
  // Add NODE Modal
  openAddNodeDetailsModal(event: any) {
    const selectedDivID = event.id;
    const dialogRef = this.dialog.open(AddNodeDetailModalComponent, {
      width: '35%'
    });
    if (event != null) {
      dialogRef.componentInstance.siteId = this.siteId;
      dialogRef.componentInstance.selectedDivID = selectedDivID;
      dialogRef.componentInstance.immediateChildNodes =
        this.immediateChildNodes;
    }

    dialogRef.afterClosed().subscribe((result) => {
      if (result.status === true) {
        const label = document.createElement('label');
        label.innerHTML = result.data.labelTag;
        document.getElementById(selectedDivID).appendChild(label);
      }
    });
  }

  getDataOnClickAndNavigateLabelClick(
    nodeRId,
    nodeName,
    entityRId,
    nodeType,
    removeElementToBreadCrumb,
    refreshStage
  ) {
    // alert('getDataOnClickAndNavigateLabelClick was called');
    const t = this;
    this.clickAndNavigateLevelItem = 2;
    this.rtDataLength = -1;
    this.displayHydraulicDataTable = false;
    console.log(
      'getDataOnClickAndNavigateLabelClick refresh --> ' + new Date()
    );

    if (refreshStage === undefined) {
      this.clickAndNavigatePageRefreshFlag = 1;
      this.stopIntervalForClickAndNavigate();
    }

    if (nodeType.indexOf('Level') !== -1) {
      /* To get MeterID details */
      this.returnedJSONArray = this.getJSONArray(entityRId);
      const meterIDbasedOnVG = {};
      const vgBasedMeterID = this.getAllMetersIdOfNodeBasedOnVirtualGroup(
        this.returnedJSONArray,
        []
      );

      // Get Energy Consumption, OnTime Analysis and sensorHealth
      const quickStatParams = {
        siteID: this.siteId,
        LoadDetails: vgBasedMeterID,
        Parameters: this.quickStatsParameters
      };
      this.clickAndNavigationService
        .getEnergyOperatingHours(quickStatParams)
        .subscribe((data) => {
          t.quickStatsData = data;
          // System Health
          t.setClickAndNavigateSystemHealth(data);
        });

      // Get Attachment and add element to breadCrumbs
      const params = {
        nodeRId: nodeRId,
        NodeName: nodeName,
        siteID: this.siteId
      };
      this.clickAndNavigationService
        .getAttachmentsForNode(params)
        .subscribe(function (data) {
          this.sensorData = data.SensorDetails;
          if (data.HtmlWithDIVContents === '') {
            console.log('HTML DIV CONTENETS IS NULL ..!!!');
          } else {
            // Map Sensor RT data to Label
            this.sensorLastUpdatedTxtime = '';
            this.sensorRTData(data.SensorDetails);

            this.bindHTMLtoChart(
              data.HtmlWithDIVContents,
              'intermidiateLevelLayout'
            );
            // Navigation Bar
            if (!removeElementToBreadCrumb && refreshStage !== 'subsequent') {
              this.addElementToBreadCrumbs(
                nodeName,
                nodeRId,
                entityRId,
                nodeType
              );
              this.entityName = nodeName;
            }
          }
        });
    } else if (nodeType.indexOf('Load') !== -1) {
      // this.meterName = nodeName;
      this.loadRTData = {};
      this.rtDataLength = -1;

      // Get MeterDetails from tree Data
      const meterDetails = this.getMeterIDforSelectedLoad(
        this.returnedJSONArray,
        entityRId
      );
      const selectedMeterDetails = meterDetails;

      // Get Quick Stats, Operating Hours and System Health for Load
      const quickStatParams = {
        siteID: this.siteId,
        LoadDetails: selectedMeterDetails,
        Parameters: t.quickStatsParameters
      };
      this.clickAndNavigationService
        .getEnergyOperatingHoursForLoad(quickStatParams)
        .subscribe((data) => {
          this.quickStatsData = {
            [selectedMeterDetails.VirtualGroupName]: data
          };
          // System Health
          this.setClickAndNavigateSystemHealth(this.quickStatsData);
        });
      /* To get Attachment if Load has any */
      const params = {
        nodeRId: nodeRId,
        NodeName: nodeName,
        siteID: this.siteId
      };
      this.clickAndNavigationService
        .getAttachmentsForNode(params)
        .subscribe(function (data) {
          if (data.HtmlWithDIVContents === '') {
            console.log('HTML DIV CONTENTS IS NULL ..!!!');
          } else {
            // To get Sensor Details
            this.sensorLastUpdatedTxtime = '';

            // To check whether LOAD is ofType hydraulic, If YES then display Sensor Data in Table Form
            this.displayHydraulicDataTable =
              data.isHydraulicLoad === 'YES' ? true : false;

            this.sensorRTData(data.SensorDetails);
            this.sensorData = data.SensorDetails;
            this.bindHTMLtoChart(
              data.HtmlWithDIVContents,
              'intermidiateLevelLayout'
            );
            // Navigation Bar
            if (!removeElementToBreadCrumb && refreshStage !== 'subsequent') {
              this.addElementToBreadCrumbs(
                nodeName,
                nodeRId,
                entityRId,
                nodeType
              );
              this.entityName = nodeName;
            }
          }
        });
      // RT data for Loads with Meter Connected
      if (meterDetails != null && meterDetails.HasMeter === 'YES') {
        const param = {
          siteId: meterDetails.siteId,
          meterId: meterDetails.meterId,
          hideLoading: false,
          electricParams: this.electricalParameters
        };
        this.loadService
          .getLastRealtimeDataForLoad(param)
          .subscribe(function (data) {
            this.loadRTData = data;
            this.rtDataLength = Object.keys(this.loadRTData).length;
          });
      }
    }

    // Page refresh
    if (this.clickAndNavigatePageRefreshFlag === 1) {
      this.intervalForClickAndNavigateRefresh = timer(
        0,
        this.clickAndNavigateDashboarInterval * 1000
      );
      this.subscription = this.intervalForClickAndNavigateRefresh.subscribe(
        () => {
          // console.log('getMetersStatus-time:' + moment().toString());
          this.getDataOnClickAndNavigateLabelClick(
            nodeRId,
            nodeName,
            entityRId,
            nodeType,
            removeElementToBreadCrumb,
            'subsequent'
          );
        }
      );

      this.clickAndNavigatePageRefreshFlag = -1;
    }
  }

  stopIntervalForClickAndNavigate() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  getJSONArray(entityRId) {
    return this.getJSONArrayForSelectedEntity(
      this.clickAndNavigateTreeData[0],
      entityRId
    );
  }

  getJSONArrayForSelectedEntity(nodeArray, selectedEntity) {
    let selectedJSONArray = [];
    for (let i = 0; i < nodeArray.nodes.length; i++) {
      if (nodeArray.RId === selectedEntity) {
        selectedJSONArray = nodeArray;
      } else {
        this.getJSONArrayForSelectedEntity(nodeArray.nodes[i], selectedEntity);
      }
    }
    return selectedJSONArray;
  }
  getAllMetersIdOfNodeBasedOnVirtualGroup(node, metersId) {
    if (node.VirtualGroupName !== undefined) {
      this.meterIDbasedOnVG[node.VirtualGroupName] =
        this.meterIDbasedOnVG[node.VirtualGroupName] || [];
      this.meterIDbasedOnVG[node.VirtualGroupName].push({
        LoadName: node.loadName,
        LoadID: node.loadId,
        LoadRId: node.RId,
        MeterID: node.meterId != null ? node.meterId : '',
        MeterRId: node.meterRId != null ? node.meterRId : ''
      });
    }
    if (node.nodes != null && node.nodes !== undefined) {
      for (let i = 0; i < node.nodes.length; i++) {
        metersId = this.getAllMetersIdOfNodeBasedOnVirtualGroup(
          node.nodes[i],
          metersId
        );
      }
    }

    return this.meterIDbasedOnVG;
  }
  /* Method to set System Health */
  setClickAndNavigateSystemHealth(data) {
    for (const key in data) {
      if (data[key].hasOwnProperty('SystemHealth')) {
        if (data[key].SystemHealth.VeryCritical > 0) {
          this.quickStatSensorHealth = 'pull-right OFF';
          this.quickStatSensorHealthMsg = 'NOT OK';
        } else if (data[key].SystemHealth.Critical > 0) {
          this.quickStatSensorHealth = 'pull-right NA';
          this.quickStatSensorHealthMsg = 'NOT OK';
        } else {
          this.quickStatSensorHealth = 'pull-right ON';
          this.quickStatSensorHealthMsg = 'OK';
        }
      }
    }
  }
  /* Method to map Sensor Readings to label */
  sensorRTData(sensorData) {
    let sensorDetails = [];
    sensorDetails = sensorData;
    if (sensorDetails != null && sensorDetails.length > 0) {
      for (let i = 0; i < sensorDetails.length; i++) {
        sensorDetails.push({
          SensorName: sensorDetails[i].inlets[0].name,
          SensorReading: sensorDetails[i].inlets[0].sensor.sensorReading,
          unit: sensorDetails[i].inlets[0].sensor.parameterUnit
        });
        let sensorRID = sensorDetails[i].inlets[0].sensor.id;
        sensorRID = 'SensorRID' + sensorRID.replace('#', '').replace(':', '');
        this.sensorLastUpdatedTxtime =
          sensorDetails[i].inlets[0].sensor.txtime != null
            ? sensorDetails[i].inlets[0].sensor.txtime
            : 'Data Not Available for Past 2 days ...!!!!';
      }
    }
  }

  // Function to bind HtmlDIVContents to CHART
  bindHTMLtoChart(htmlDIVContents, wrapperID) {
    const newchar = '',
      backSlash = '\\';
    const wrapperElement = document.getElementById(wrapperID);
    wrapperElement.innerHTML = '';

    const htmlContents = htmlDIVContents.split(backSlash).join(newchar);
    // wrapperElement.appendChild(htmlContents);
    wrapperElement[0].appendChild(htmlContents);
  }

  // Add element to Breadcrumbs
  addElementToBreadCrumbs(nodeName, nodeRId, entityRId, nodeType) {
    const breadCrumbItem = {
      NodeName: nodeName,
      nodeRID: nodeRId,
      EntityRID: entityRId,
      nodeType: nodeType
    };
    // Navigation Bar
    this.breadCrumData.push(breadCrumbItem);
    this.breadCrumData = JSON.parse(this.breadCrumData);
  }

  /* Method to get METER ID for selected Load */
  getMeterIDforSelectedLoad(nodeArray, loadRID) {
    let meterDetails;
    for (let i = 0; i < nodeArray.nodes.length; i++) {
      const array = nodeArray.nodes[i];
      if (array.nodes.length > 0) {
        for (let j = 0; j < array.nodes.length; j++) {
          if (array.nodes[j].RId === loadRID) {
            const hasMeter =
              array.nodes[j].meterId === undefined ||
              array.nodes[j].meterRId === undefined
                ? 'NO'
                : 'YES';
            meterDetails = {
              siteId: this.siteId,
              LoadName: array.nodes[j].loadName,
              LoadRId: array.nodes[j].RId,
              LoadID: array.nodes[j].loadId,
              meterId: array.nodes[j].meterId,
              MeterRID: array.nodes[j].meterRId,
              HasMeter: hasMeter,
              VirtualGroupName: array.nodes[j].VirtualGroupName
            };
            console.log('************* METER DETAILS *********************');
            console.log(JSON.stringify(meterDetails));
            return meterDetails;
          }
        }
      } else {
        console.log('METER NOT FOUND..!!');
      }
    }
  }
}
